/**
 * Cómo se escribe un valor de filtro que viene de una maestra: el nombre delante y la clave
 * entre paréntesis —"PLATAFORMA DE COMUNICACIONES SAS (830509557)"—, que es el formato que la
 * app vieja usaba tanto en el desplegable como en las búsquedas recientes.
 *
 * Vive aquí, y no en cada pantalla, porque el desplegable del filtro y la tarjeta del histórico
 * tienen que escribir lo mismo: si se separan, el usuario elige una cosa y luego lee otra.
 */
export const formatFilterOptionLabel = (
  name: string | undefined | null,
  value: string | undefined | null
): string => {
  const cleanName = name ?? '';
  const cleanValue = value ?? '';
  if (cleanName && cleanValue && cleanName !== cleanValue) {
    return `${cleanName} (${cleanValue})`;
  }
  return cleanName || cleanValue;
};
